import { render, staticRenderFns } from "./SidebarButton.vue?vue&type=template&id=a14b5cf4&"
import script from "./SidebarButton.vue?vue&type=script&lang=js&"
export * from "./SidebarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sebastian/Projekte/CD-Systeme/nextgenkonfi/konfiguratornextgen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a14b5cf4')) {
      api.createRecord('a14b5cf4', component.options)
    } else {
      api.reload('a14b5cf4', component.options)
    }
    module.hot.accept("./SidebarButton.vue?vue&type=template&id=a14b5cf4&", function () {
      api.rerender('a14b5cf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/SidebarButton.vue"
export default component.exports